<template>
  <div>
    <!-- Modificatore della variabile Act-For per richiedere dati di altre aziende associate al referente aziendale -->
    <SwitcherAziende />
    <PageTagline :is_ref_azi_area="true" :elements="tagline_elem" />
    <!-- Overlay durante il caricamento delle campagne -->
    <b-overlay :show="overlay_show" rounded="sm">
      <!-- Card di contenimento della Conversione Premio -->
      <b-card class="mr-1 ml-1">
        <!-- Titolo e creazione di una nuova campagna -->
        <div class="d-flex align-items-center justify-content-between mb-3">
          <h4 class="mb-0">Conversione Premio</h4>
          <b-button variant="primary" @click="apriModaleCampagna()">
            <b-icon icon="plus-circle" class="mr-1" />
            Nuova campagna
          </b-button>
        </div>
        <!-- Selezione della campagna e menu delle azioni -->
        <b-row class="align-items-end">
          <b-col cols="12" md="8">
            <b-form-group label="Elenco campagne">
              <b-form-select
                v-model="id_campagna_selezionata"
                :options="opzioni_campagne"
              />
            </b-form-group>
          </b-col>
          <b-col cols="12" md="4" class="mb-3">
            <b-dropdown
              text="Azioni campagna"
              variant="outline-primary"
              :disabled="!campagna_selezionata"
            >
              <!-- Modifica della campagna -->
              <b-dropdown-item
                v-if="campagna_selezionata && campagna_selezionata.stato !== 'CHIUSO'"
                @click="apriModaleCampagna(campagna_selezionata)"
              >
                <b-icon icon="pencil-square" class="mr-2 text-primary" />
                <span class="text-primary">Modifica campagna</span>
              </b-dropdown-item>
              <!-- Esportazione Excel -->
              <b-dropdown-item
                :disabled="esportazione_in_corso"
                @click="esportaExcel"
              >
                <b-spinner v-if="esportazione_in_corso" small class="mr-2" />
                <b-icon v-else icon="download" class="mr-2 text-primary" />
                <span class="text-primary">
                  {{ esportazione_in_corso ? 'Esportazione...' : 'Scarica Excel' }}
                </span>
              </b-dropdown-item>
              <!-- Annullamento della campagna -->
              <b-dropdown-item
                v-if="campagna_selezionata && ['NUOVO', 'PUBBLICATO'].includes(campagna_selezionata.stato)"
                @click="confermaCambioStato('ANNULLATO')"
              >
                <b-icon icon="x-circle" class="mr-2 text-danger" />
                <span class="text-danger">Annulla campagna</span>
              </b-dropdown-item>
            </b-dropdown>
          </b-col>
        </b-row>
        <!-- Informazioni della campagna selezionata -->
        <CPCampagnaHeader
          v-if="campagna_selezionata"
          :campagna="campagna_selezionata"
          :esportazione_in_corso="esportazione_in_corso"
          @cambio-stato="confermaCambioStato"
          @modifica="apriModaleCampagna"
          @esporta-excel="esportaExcel"
        />
      </b-card>
    </b-overlay>

    <!-- Riepilogo visibile soltanto per campagne pubblicate o chiuse -->
    <CPRiepilogo
      v-if="campagna_selezionata && ['PUBBLICATO', 'CHIUSO'].includes(campagna_selezionata.stato)"
      :dipendenti_premi="dipendenti_premi_originali"
    />

    <!-- Card di contenimento della gestione premi -->
    <CPDipendentiPremi
      v-if="campagna_selezionata"
      :key="campagna_selezionata.id"
      :campagna="campagna_selezionata"
      :dipendenti_premi="dipendenti_premi"
      :numero_modifiche="dipendenti_premi_modificati.length"
      :salvataggio_in_corso="salvataggio_in_corso"
      @aggiorna-premio="aggiornaPremio($event.dipendente, $event.valore)"
      @aggiorna-maggiorazione="aggiornaMaggiorazione($event.dipendente, $event.valore)"
      @salva-premi="salvaPremi"
    />

    <!-- Modale per la creazione e la modifica delle campagne -->
    <CampagnaModal
      v-model="campagna_modal_show"
      :campagna="campagna_da_modificare"
      @campagna-creata="campagnaSalvata($event, false)"
      @campagna-modificata="campagnaSalvata($event, true)"
    />

    <!-- Modale per i cambi di stato che richiedono un motivo -->
    <b-modal
      v-model="cambio_stato_modal_show"
      :title="nuovo_stato_campagna === 'ANNULLATO' ? 'Annullamento campagna' : 'Ripubblicazione campagna'"
      ok-title="Conferma"
      cancel-title="Annulla"
      :ok-disabled="!motivo_cambio_stato.trim() || cambio_stato_loading"
      :busy="cambio_stato_loading"
      centered
      @ok.prevent="salvaCambioStato"
    >
      <b-form-group label="Motivo del cambio di stato" label-for="motivo-cambio-stato">
        <b-form-textarea
          id="motivo-cambio-stato"
          v-model="motivo_cambio_stato"
          rows="3"
          maxlength="255"
          placeholder="Inserisci il motivo..."
          required
        />
        <small class="text-muted">
          {{ motivo_cambio_stato.length }}/255 caratteri
        </small>
      </b-form-group>
    </b-modal>

  </div>
</template>

<script>
import PageTagline from "@/components/PageTagline";
import SwitcherAziende from "@/components/refaziendale/SwitcherAziende.vue";
import axios from "axios";
import { apiUrl } from "@/apiUrl";
import { generalLib } from "@/generalLib";
import moment from "moment";
import CampagnaModal from "@/components/conversionepremio/CampagnaModal.vue";
import CPCampagnaHeader from "@/components/conversionepremio/CPCampagnaHeader.vue";
import CPDipendentiPremi from "@/components/conversionepremio/CPDipendentiPremi.vue";
import CPRiepilogo from "@/components/conversionepremio/CPRiepilogo.vue";

export default {

  name: "ConversionePremio",

  components: {
    PageTagline,
    SwitcherAziende,
    CampagnaModal,
    CPCampagnaHeader,
    CPDipendentiPremi,
    CPRiepilogo
  },

  data() {
    return {
      tagline_elem: [
        { text: "Conversione Premio", link: "office-conversione-premio" }
      ],

      // Mostra l'overlay durante il caricamento delle campagne.
      overlay_show: false,

      // Elenco delle campagne dell'azienda restituito dal backend.
      lista_campagne: [],

      // Identificativo della campagna selezionata.
      id_campagna_selezionata: null,

      // Controlla la visualizzazione della modale di creazione e modifica.
      campagna_modal_show: false,

      // Campagna da modificare; null indica la creazione di una nuova campagna.
      campagna_da_modificare: null,

      // Gestione della modale per i cambi di stato con motivo obbligatorio.
      cambio_stato_modal_show: false,
      nuovo_stato_campagna: null,
      motivo_cambio_stato: "",
      cambio_stato_loading: false,

      // Elenco dei dipendenti e dei premi della campagna selezionata.
      dipendenti_premi: [],

      // Valori originali per individuare i premi e le maggiorazioni modificati.
      dipendenti_premi_originali: [],

      // Indica se è in corso il salvataggio dei premi.
      salvataggio_in_corso: false,

      // Indica se è in corso la generazione e il download dell'Excel.
      esportazione_in_corso: false

    };
  },

  computed: {

    // Prepara le opzioni del selettore con descrizione, periodo e stato.
    opzioni_campagne() {
      return this.lista_campagne.map((campagna) => ({
        value: campagna.id,
        text: `${campagna.descrizione} (${moment(campagna.data_inizio).format("DD-MM-YYYY")} - ${moment(campagna.data_fine).format("DD-MM-YYYY")}) - ${campagna.stato}`
      }));
    },

    // Restituisce i dati della campagna selezionata.
    campagna_selezionata() {
      return this.lista_campagne.find(campagna => campagna.id === this.id_campagna_selezionata) || null;
    },

    // Individua i dipendenti con premio o maggiorazione modificati.
    dipendenti_premi_modificati() {

      // Confronta gli importi normalizzando i valori numerici.
      const normalizzaImporto = valore => {
        if (valore === null || valore === undefined || valore === "") {
          return null;
        }
        return Number(valore);
      };

      // Confronta ogni dipendente con i dati originali caricati dal backend.
      return this.dipendenti_premi.filter(dipendente => {

        const originale = this.dipendenti_premi_originali.find(
          item => item.id_azi_dip === dipendente.id_azi_dip
        );

        if (!originale) return false;

        const premioModificato =
          normalizzaImporto(dipendente.valore) !== normalizzaImporto(originale.valore);

        const maggiorazioneModificata =
          normalizzaImporto(dipendente.percentuale_maggiorazione) !==
          normalizzaImporto(originale.percentuale_maggiorazione);

        return premioModificato || maggiorazioneModificata;

      });
    }
  },

  created: function () {
    this.caricaCampagne();
  },

  watch: {

    // Aggiorna i premi quando cambia la campagna selezionata.
    id_campagna_selezionata() {
      this.dipendenti_premi = [];
      this.dipendenti_premi_originali = [];
      this.caricaPremi();
    }
  },

  methods: {

    // Recupera l'elenco delle campagne dell'azienda.
    caricaCampagne(idCampagna = null) {
      this.overlay_show = true;

      return axios.get(apiUrl.conversionepremioapi.campagne)
      .then((response) => {
        this.lista_campagne = response.data;

        // Seleziona la campagna richiesta oppure quella più recente.
        const campagna = idCampagna !== null
          ? this.lista_campagne.find(c => c.id === idCampagna)
          : null;

        this.id_campagna_selezionata = campagna
          ? campagna.id
          : (this.lista_campagne.length > 0 ? this.lista_campagne[0].id : null);

        this.overlay_show = false;
      })
      .catch((error) => {
        this.overlay_show = false;
        generalLib.backend_error_message_box(
          this, error.response ? error.response.data : error
        );
      });
    },

    // Recupera i dipendenti e i premi della campagna selezionata.
    async caricaPremi() {
      if (!this.id_campagna_selezionata) {
        this.dipendenti_premi = [];
        this.dipendenti_premi_originali = [];
        return;
      }

      this.overlay_show = true;

      try {
        const response = await axios.get(
          `${apiUrl.conversionepremioapi.campagne}${this.id_campagna_selezionata}/premi/`
        );

        // Prepara il nominativo completo per la visualizzazione e l'ordinamento.
        this.dipendenti_premi = response.data.dipendenti.map(dipendente => ({
          ...dipendente,
          dipendente: `${dipendente.cognome} ${dipendente.nome}`.trim()
        }));

        // Conserva una copia indipendente dei dati caricati dal backend.
        this.dipendenti_premi_originali = this.dipendenti_premi.map(dipendente => ({
          ...dipendente
        }));

      } catch (error) {
        this.dipendenti_premi = [];
        this.dipendenti_premi_originali = [];

        generalLib.backend_error_message_box(
          this,
          error.response ? error.response.data : error
        );

      } finally {
        this.overlay_show = false;
      }
    },

    // Apre la modale in creazione oppure in modifica con i dati della campagna selezionata.
    apriModaleCampagna(campagna = null) {
      this.campagna_da_modificare = campagna;
      this.campagna_modal_show = true;
    },

    // Aggiorna l'elenco e conferma la creazione o modifica della campagna.
    async campagnaSalvata(campagna, isModifica) {
      await this.caricaCampagne(campagna.id);
      await this.caricaPremi();
      this.$bvToast.toast(
        isModifica ? "Campagna modificata con successo." : "Campagna creata con successo.",
        {
          title: isModifica ? "Modifica completata" : "Creazione completata",
          variant: "success",
         solid: true
        }
      );
    },

    // Richiede conferma prima di modificare lo stato della campagna.
    async confermaCambioStato(nuovoStato) {
      const statoAttuale = this.campagna_selezionata.stato;

      const richiedeMotivo =
        nuovoStato === "ANNULLATO" ||
        (nuovoStato === "PUBBLICATO" && statoAttuale !== "NUOVO");

      if (richiedeMotivo) {
        // Apre la modale per inserire il motivo obbligatorio del cambio di stato.
        this.apriModaleCambioStato(nuovoStato);
        return;
      }

      const messaggio = nuovoStato === "PUBBLICATO"
        ? "Confermi la pubblicazione della campagna?"
        : "Confermi la chiusura della campagna? Una volta chiusa, la campagna non potrà più essere riaperta.";

      const confermato = await this.$bvModal.msgBoxConfirm(messaggio, {
        title: "Conferma cambio stato",
        okTitle: "Conferma",
        cancelTitle: "Annulla",
        okVariant: "primary",
        centered: true
      });

      if (!confermato) return;

      await this.cambiaStatoCampagna(nuovoStato);
    },

    // Esegue il cambio di stato della campagna e aggiorna i dati visualizzati.
    async cambiaStatoCampagna(nuovoStato, motivo = "") {
      const idCampagna = this.campagna_selezionata.id;

      this.overlay_show = true;

      try {
        const response = await axios.patch(
          `${apiUrl.conversionepremioapi.campagne}${idCampagna}/stato/`,
          {
            stato: nuovoStato,
            motivo: motivo
          }
        );

        await this.caricaCampagne(idCampagna);
        await this.caricaPremi();

        this.$bvToast.toast("Stato della campagna aggiornato con successo.", {
          title: "Cambio stato completato",
          variant: "success",
          solid: true
        });

        return response.data;

      } catch (error) {
        generalLib.backend_error_message_box(
          this,
          error.response ? error.response.data : error
        );

      } finally {
        this.overlay_show = false;
      }
    },

    // Apre la modale per i cambi di stato che richiedono un motivo.
    apriModaleCambioStato(nuovoStato) {
      this.nuovo_stato_campagna = nuovoStato;
      this.motivo_cambio_stato = "";
      this.cambio_stato_modal_show = true;
    },

    // Conferma il cambio di stato con motivo obbligatorio.
    async salvaCambioStato() {
      const motivo = this.motivo_cambio_stato.trim();

      if (!motivo || this.cambio_stato_loading) return;

      this.cambio_stato_loading = true;

      try {
        const risultato = await this.cambiaStatoCampagna(
          this.nuovo_stato_campagna,
          motivo
        );

        // Chiude la modale soltanto se il backend ha completato l'operazione.
        if (risultato) {
          this.cambio_stato_modal_show = false;
        }
      } finally {
        this.cambio_stato_loading = false;
      }
    },

    // Aggiorna il valore numerico del premio
    aggiornaPremio(dipendente, valore) {
      this.$set(dipendente, "valore", valore);
    },

    // Aggiorna la maggiorazione personalizzata del dipendente
    aggiornaMaggiorazione(dipendente, valore) {
      this.$set(dipendente, "percentuale_maggiorazione", valore);
    },

    // Salva i premi e le maggiorazioni modificati.
    async salvaPremi() {
      if ( this.salvataggio_in_corso || !this.id_campagna_selezionata || this.dipendenti_premi_modificati.length === 0) {
        return;
      }

      // Prepara solamente i dipendenti con dati modificati.
      const premi = this.dipendenti_premi_modificati.map(dipendente => ({
        id_azi_dip: dipendente.id_azi_dip,
        valore: Number(dipendente.valore).toFixed(2),
        percentuale_maggiorazione:
          dipendente.percentuale_maggiorazione === null ||
          dipendente.percentuale_maggiorazione === ""
            ? null
            : Number(dipendente.percentuale_maggiorazione).toFixed(2)
      }));

      this.salvataggio_in_corso = true;

      try {
        await axios.post(
          `${apiUrl.conversionepremioapi.campagne}${this.id_campagna_selezionata}/premi/`,
          { premi }
        );

        // Ricarica i dati aggiornati e la copia originale.
        await this.caricaPremi();

        this.$bvToast.toast("Premi e maggiorazioni salvati correttamente.", {
          title: "Salvataggio completato",
          variant: "success",
          solid: true
        });

      } catch (error) {
        console.error("Errore durante il salvataggio dei premi:", error);

        this.$bvToast.toast("Impossibile salvare le modifiche ai premi.", {
          title: "Errore di salvataggio",
          variant: "danger",
          solid: true
        });
      } finally {
        this.salvataggio_in_corso = false;
      }
    },

    // Esporta in Excel tutti i premi della campagna selezionata.
    async esportaExcel() {
      if (this.esportazione_in_corso || !this.id_campagna_selezionata) {
        return;
      }

      this.esportazione_in_corso = true;

      try {
        // Richiede al backend il file Excel completo della campagna.
        const response = await axios.get(
          `${apiUrl.conversionepremioapi.campagne}${this.id_campagna_selezionata}/export/`,
          { responseType: "blob" }
        );

        // Crea un URL temporaneo per scaricare il file restituito dal backend.
        const blob = new Blob([response.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        });

        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");

        link.href = url;
        // Recupera il nome dell'azienda e della campagna selezionata.
        const nomeAzienda = this.$store.state.session_infos.act_for.nome;
        const nomeCampagna = this.campagna_selezionata.descrizione;

        // Data e ora locale dell'esportazione, fino ai secondi.
        const dataEsportazione = moment().format("YYYY-MM-DD_HH-mm-ss");

        // Rimuove i caratteri non consentiti nei nomi dei file.
        const pulisciNome = (valore) =>
          String(valore).replace(/[\\/:*?"<>|]/g, "-").trim();

        // Compone il nome del file Excel.
        link.download = `${pulisciNome(nomeAzienda)} - ${pulisciNome(nomeCampagna)} - ${dataEsportazione}.xlsx`;

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        window.URL.revokeObjectURL(url);

      } catch (error) {
        console.error("Errore durante l'esportazione Excel:", error);

        this.$bvToast.toast("Impossibile esportare il file Excel.", {
          title: "Errore esportazione",
          variant: "danger",
          solid: true
        });

      } finally {
        this.esportazione_in_corso = false;
      }
    }

  }
};
</script>
